<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <p>中科名兽医</p>
    <router-link to="pigPrice" class="router-style">中科名兽医生物安全测评</router-link><br>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h1 {
  font-size: 16px;
  padding-bottom: 20px;
}
p {
  font-size: 14px;
}
.router-style {
  font-size: 14px;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
